// extracted by mini-css-extract-plugin
export default {"summary":"CsyLVe","subtotals":"nHk5t3","subtotalsRow":"uThxeR","totals":"OwKP3X"};